<template>
  <div class="dialog-wrap">
    <el-dialog title="调剂信息对比" :close-on-click-modal="false" :visible.sync="dialogVisible" @close="handleClose" width="730px">
      <div class="main">
        <div class="main-item">
          <div class="item-label"></div>
          <div class="item-value"><span class="item-title">系统已录入</span></div>
          <div class="item-value"><span class="item-title">调剂信息补充</span></div>
        </div>
        <div class="main-item">
          <div class="item-label"><span>年份</span></div>
          <div class="item-value">{{content.adjustExist?content.adjustExist.year:'无'}}</div>
          <div class="item-value">{{content.year}}</div>
        </div>
        <div class="main-item">
          <div class="item-label"><span>院校名称</span></div>
          <div class="item-value">
            {{content.adjustExist?content.adjustExist.college_name:'无'}}
          </div>
          <div class="item-value">{{content.college_name}}</div>
        </div>
        <div class="main-item">
          <div class="item-label"><span>专业名称</span></div>
          <div class="item-value">{{content.adjustExist?`(${content.adjustExist.major_code})${content.adjustExist.major_name}`:'无'}}
          </div>
          <div class="item-value">{{`(${content.major_code})${content.major_name}`}}</div>
        </div>
        <div class="main-item">
          <div class="item-label"><span>学院名称</span></div>
          <div class="item-value">{{content.adjustExist?content.adjustExist.academy_name:'无'}}</div>
          <div class="item-value">{{content.academy_name}}</div>
        </div>
        <div class="main-item">
          <div class="item-label"><span>招生类型</span></div>
          <div class="item-value">{{content.adjustExist?formateEnrol_type(content.adjustExist.enrol_type):'无'}}</div>
          <div class="item-value">{{formateEnrol_type(content.enrol_type)}}</div>
        </div>
        <div class="main-item">
          <div class="item-label"><span>拟招生人数</span></div>
          <div class="item-value">{{content.adjustExist?content.adjustExist.user_count+'人':'无'}}</div>
          <div class="item-value">{{content.user_count +'人'}}</div>
        </div>
        <div class="main-item">
          <div class="item-label"><span>联系老师</span></div>
          <div class="item-value">{{content.adjustExist?content.adjustExist.contact_name:'无'}}</div>
          <div class="item-value">{{content.contact_name}}</div>
        </div>
        <div class="main-item">
          <div class="item-label"><span>联系方式</span></div>
          <div class="item-value">{{content.adjustExist?content.adjustExist.contact_mobile:'无'}}</div>
          <div class="item-value">{{content.contact_mobile}}</div>
        </div>
        <div class="main-item">
          <div class="item-label"><span>调剂最高分</span></div>
          <div class="item-value">{{content.adjustExist?content.adjustExist.high_score:'无'}}</div>
          <div class="item-value">{{content.high_score}}</div>
        </div>
        <div class="main-item">
          <div class="item-label"><span>调剂最低分</span></div>
          <div class="item-value">{{content.adjustExist?content.adjustExist.low_score:'无'}}</div>
          <div class="item-value">{{content.low_score}}</div>
        </div>
        <div class="main-item">
          <div class="item-label"><span>其他备注</span></div>
          <div class="item-value">{{content.adjustExist?content.adjustExist.other_remark:'无'}}</div>
          <div class="item-value">{{content.other_remark}}</div>
        </div>
        <div class="main-item">
          <div class="item-label"><span>原文地址</span></div>
          <div class="item-value">
            <el-link type="primary" @click="locationGo(content.adjustExist.source_website)">{{content.adjustExist?content.adjustExist.source_website:'无'}}</el-link>
          </div>
          <div class="item-value">
            <el-link type="primary" @click="locationGo(content.source_website)">{{content.source_website}}</el-link>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="height:30px">
        <el-button size="small" type="primary" style="float:left;" plain @click="handleEdit">修 改</el-button>
        <el-button size="small" type="danger" @click="opendialogFormVisible" :disabled="![0,null].includes(content.status)">拒 绝
        </el-button>
        <el-button type="primary" size="small" @click="Edit('确定要通过吗？',1)" :disabled="![0,null].includes(content.status)">通 过
        </el-button>
      </div>
    </el-dialog>
    <SupplementEdit :visible="SupplementEditVisible" @close="closeSupplementEditVisible" :content="SupplementEditContent" :userType="1" />
    <el-dialog title="" :visible.sync="dialogFormVisible" width="500px">
      <el-form>
        <el-form-item label="拒绝理由">
          <el-input type="textarea" v-model="refuse_reason" autocomplete="off" placeholder="请填写拒绝理由"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="Edit('确定要拒绝吗？',2)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adjustAddOne, adjustAddcheck } from "@/api/adjust";
import SupplementEdit from "@/components/dialog/supplement/SupplementEdit.vue";
export default {
  components: {
    SupplementEdit
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: false
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      SupplementEditVisible: false, // 编辑弹窗
      SupplementEditContent: {},
      content: {},
      dialogFormVisible: false,// 拒绝理由弹窗
      refuse_reason: "",
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    id(val) {
      this.fetchAdjustAddOne(val)
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleEdit() {
      this.SupplementEditContent = JSON.parse(JSON.stringify(this.content))
      this.SupplementEditVisible = !this.SupplementEditVisible
    },
    fetchAdjustAddOne(id) {
      adjustAddOne({ id: id }).then(res => {
        this.content = res
      })
    },
    formateEnrol_type(val) {
      switch (val) {
        case 1:
          return '全日制'
        case 2:
          return '非全日制'
        default:
          break;
      }
    },
    closeSupplementEditVisible() {
      this.SupplementEditVisible = false
      this.fetchAdjustAddOne(this.id)
    },
    opendialogFormVisible() {
      this.dialogFormVisible = !this.dialogFormVisible
    },
    Edit(text, status) {
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let query = {
            id: this.content.id,
            status: status,
            refuse_reason: this.refuse_reason
          };
          adjustAddcheck(query).then((res) => {
            this.$nextTick(() => {
              this.dialogFormVisible = false
              this.fetchAdjustAddOne(this.content.id)
            });
          });
        })
        .catch(() => {
          this.$notify.error({
            title: "提示",
            message: "已取消操作",
          });
        });
    },
    locationGo(url = "") {
      window.open(`http://${url}`, 'top')
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  display: flex;
  flex-direction: column;
  .main-item {
    height: 50px;
    width: 100%;
    display: flex;
    border: solid #ebeef5 1px;
    div {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .item-label {
      border-right: solid #ebeef5 1px;
      width: 100px;
      height: 100%;
      span {
        font-size: 14px;
        font-family: PingFang SC;
        color: #707070;
        opacity: 1;
      }
    }
    .item-value {
      width: 286px;
      height: 100%;
      span {
        font-size: 14px;
        font-family: PingFang SC;
        color: #333333;
        opacity: 1;
      }
      .item-title {
        font-size: 18px;
      }
    }
    :nth-child(2) {
      border-right: solid #ebeef5 1px;
    }
  }
}
</style>
